import { getGPUTier } from 'detect-gpu';
import { sha256 } from 'js-sha256';

export interface PerformanceInfo {
    isHighEnd: boolean,
    details:{
        cpuCores: number,
        cpuScore: number,
        ramGB: number,
        gpu: string|undefined,
        gpuFPS: number|undefined,
        gpuTier: number,
    }
}

export async function cpuScore(ms = 150) : Promise<number> {
  const data = new Uint8Array(1 << 16);
  let hashes = 0, t0 = performance.now();
  while (performance.now() - t0 < ms) {
    sha256.update(data); hashes++;
  }
  return hashes / (ms / 1000);
}

export async function GetPerformanceInfo(showInAlert: boolean = false) : Promise<PerformanceInfo> {
    console.log("Ejecutando prueba de rendimiento básica...");
    let isHighEnd = true;

    const baselineSpecs = {
        cores:  navigator.hardwareConcurrency ?? 1,
        ramGB:  navigator["deviceMemory"] ?? 4,
        uaGPU:  navigator["gpu"]?.requestAdapter ? null : undefined, // left null, filled later
        dpr:    window.devicePixelRatio
    };
    if(baselineSpecs.ramGB < 5)
        isHighEnd = false;

    const cpuTier = await cpuScore();
    if(cpuTier < 800)
        isHighEnd = false;

    const gpuTier = await getGPUTier();
    console.log(gpuTier);
    if(gpuTier.tier < 3)
        isHighEnd = false;

    const info: PerformanceInfo = {
        isHighEnd: isHighEnd,
        details:{
            cpuCores: baselineSpecs.cores,
            ramGB: baselineSpecs.ramGB,
            cpuScore: cpuTier,
            gpu: gpuTier.gpu,
            gpuFPS: gpuTier.fps,
            gpuTier: gpuTier.tier,
        }
    }
    console.log("performance", info);

    if(showInAlert){
        const message = `${info.isHighEnd === false ? 'Dispositivo de BAJO Rendimiento :(' : 'Dispositivo de ALTO Rendimiento :)'}\nNúcleos Detectados: ${info.details.cpuCores}\nPuntaje CPU: ${info.details.cpuScore}\nRAM Disponible: ${info.details.ramGB}GB\nGPU: ${info.details.gpu}\nFPS GPU: ${info.details.gpuFPS}\nTier GPU: ${info.details.gpuTier}`;
        alert(message)
    }
    return info; 
};
